'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { ChallengeHeader } from './Header';

export const ChallengeHeaderAnimated = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      className="flex flex-col items-center gap-6 text-center"
    >
      <ChallengeHeader />
    </motion.div>
  );
};
